export const PERMANENT_TOAST_INTERVAL = -1;
export const DEFAULT_TOAST_TIMEOUT = 10000;
